import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

import { UserInfo } from './Model/UserInfo';
import { environment } from '../../../../environments/environment';

@Injectable()
export class UserinfoService {

  userinfo:UserInfo;
  baseUrl: string;
  path: string;


  constructor(
    public http:HttpClient
  ) {
   console.log('[UserinfoService] constructor called');
   this.baseUrl =  `${environment.apiHost}`;
   this.path = '/makpak/userinfo';
   // Load cached user info if present to avoid null on refresh
   try {
     const cached = sessionStorage.getItem('USERINFO_CACHE');
     if (cached) {
       this.userinfo = JSON.parse(cached);
       console.log('[UserinfoService] loaded userinfo from cache');
     }
   } catch (e) {
     console.warn('[UserinfoService] failed to parse userinfo cache', e);
   }
  }

  async loadUserInfo():Promise<UserInfo> {
    console.log('[UserinfoService] loadUserInfo invoked; pathname=', window.location.pathname);
    // If on callback route and token not yet present, defer (APP_INITIALIZER waits for readiness so this is rare)
    const tokenPresent = !!sessionStorage.getItem('LOGIN_TOKEN');
    if (window.location.pathname.includes('/auth/cim') && !tokenPresent) {
      console.log('[UserinfoService] callback route without token yet - returning cached userinfo');
      return this.userinfo;
    }
    const response = await this.http.get(this.baseUrl + this.path).toPromise();
    console.log('resounce from backend: ', response);
    this.userinfo = JSON.parse(JSON.stringify(response));
    console.log('userdata: ', this.userinfo);
    try { sessionStorage.setItem('USERINFO_CACHE', JSON.stringify(this.userinfo)); } catch {}
    return this.userinfo;
  }

  getUserinfo():UserInfo{
    return this.userinfo;
  }

  setUserinfo(user: UserInfo){
    this.userinfo=user;
  }
}


